import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const deliverables = [{
  title: 'Guía Protocolo SOS (PDF)',
  desc: 'El paso a paso exacto para aplicar el Ancla de Calma.'
}, {
  title: "El Guion de 'Cero Explicaciones'",
  desc: 'Qué decir (y qué callar) para no escalar la crisis.'
}, {
  title: 'Kit de Supervivencia en el Súper',
  desc: 'Cómo blindar las salidas públicas y manejar a los extraños que juzgan.'
}, {
  title: 'Checklist de Mochila de Emergencia',
  desc: 'Los 4 elementos que deben ir contigo a todas partes.'
}, {
  title: 'Hoja de Registro de Gatillos',
  desc: 'Para identificar el patrón antes de que ocurra el siguiente estallido.'
}];
export function WhatYouGet() {
  return <section className="bg-cream py-20 px-6" data-id="element-183">
      <div className="max-w-4xl mx-auto" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-185">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-186">
            Todo lo que necesitas para recuperar el control
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-187">
            Herramientas prácticas, directas al grano y diseñadas para usarse en
            el mundo real, no solo en la oficina del terapeuta.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-4" data-id="element-188">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex gap-4 bg-white p-4 rounded-lg shadow-sm border border-[#e8e0d5]" data-id="element-189">
              <CheckCircle2 className="w-6 h-6 text-teal shrink-0 mt-0.5" data-id="element-190" />
              <div data-id="element-191">
                <h4 className="font-bold text-navy" data-id="element-192">{item.title}</h4>
                <p className="text-sm text-gray-600 mt-1" data-id="element-193">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}